import React from 'react';
import classnames from 'classnames/bind';
import { excludeNoBreakSpace, getHighlighterPattern } from "../../utils";
import { Markup } from "../../../../internal/Markup";
import styles from './Highlighter.css';
var cx = classnames.bind(styles);
export var Highlighter = function Highlighter(_ref) {
  var text = _ref.text,
      highlight = _ref.highlight;
  var parts = text.split(new RegExp("(".concat(getHighlighterPattern(highlight), ")"), 'gi'));
  return /*#__PURE__*/React.createElement(React.Fragment, null, parts.map(function (part, index) {
    return excludeNoBreakSpace(part).toLowerCase() === highlight.toLowerCase() ?
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key
    React.createElement("mark", {
      key: "find_result_".concat(index),
      className: cx('mark')
    }, /*#__PURE__*/React.createElement(Markup, {
      text: part
    })) :
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key
    React.createElement(Markup, {
      key: "find_result_".concat(index),
      text: part
    });
  }));
};